import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { PhieuNhapKho, ChiTietPhieuNhapKho } from '../kho-nhap-kho-page-model/kho-nhap-kho-page.model';

const API_ROOT_URL = environment.ApiRoot + '/kho';

@Injectable()
export class NhapKhoPageService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	lastData$: BehaviorSubject<PhieuNhapKho[]> = new BehaviorSubject([]);
	dataNew$: BehaviorSubject<number[]> = new BehaviorSubject([]);
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;

	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }

	/*-------------------------------GET Method----------------------------- */
	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/PhieuNhapKho_List', { 
			headers: httpHeaders,
			params: httpParams
		});
	}
	getChiTiet(item: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PhieuNhapKho_Get_Detail`;
		return this.http.post<any>(url,item, { headers: httpHeaders });
	}
	getDSVTK(IdKho: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/dungchung' + `/ViTriKho_List?IdKho=${IdKho}` ;
		return this.http.get<any>(url , { headers: httpHeaders });
	}
	getListGhiChu(Id: number[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/kho' + `/TTHV_Get_GhiChu` ;
		return this.http.post<any>(url, Id, { headers: httpHeaders });
	}
	getItemById(Id): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/NK_Get_Item?Id=${Id}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	uploadFileImport(data): Observable<any> {
		const url = API_ROOT_URL + '/PhieuNhapKho_UploadFile';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	downloadTemplate(): string {
		return API_ROOT_URL + `/NKTemplateImport`;
	}
	danhSachNCC_NhapKhoTheoPhieu(Id : number): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set("Id", Id.toString());
		return this.http.get<any>(API_ROOT_URL + '/DanhSachNCC_NhapKhoTheoPhieu', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	download(IdAttachment: number): Observable<Blob>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set("IdAttachment", IdAttachment.toString());
		return this.http.get<Blob>(API_ROOT_URL + '/DownLoadFile', {
		  headers: httpHeaders,
		  params: httpParams,
		  responseType: 'blob' as 'json'
		});
	}
	/*---------------------------------------------------------------------- */
	

	/*-------------------------------POST Method---------------------------- */
	add(item: PhieuNhapKho): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuNhapKho>(API_ROOT_URL+'/PhieuNhapKho_Insert', item, { headers: httpHeaders });
	}
	addDetail(item:ChiTietPhieuNhapKho): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<ChiTietPhieuNhapKho>(API_ROOT_URL+'/PhieuNhapKho_Insert_Detail', item, { headers: httpHeaders });
	}
	updateWithDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuNhapKho>(API_ROOT_URL+'/PhieuNhapKho_Update_With_Detail', item, { headers: httpHeaders });
	}
	updateHHState(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuNhapKho>(API_ROOT_URL+'/PhieuNhapKho_Update_StateHH', item, { headers: httpHeaders });
	}
	delete(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PhieuNhapKho_Delete?IdNk=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	XacNhanVTLuuKho(IdNk: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PhieuNhapKho_Update_StateConfirmWeb?IdNk=${IdNk}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	XacNhanVTLuuKhoDetail(listIdCtNk: number[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PhieuNhapKho_Update_StateConfirmWebDetail`;
		return this.http.post<any>(url, listIdCtNk, { headers: httpHeaders });
	}
	ChangeVTK(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuNhapKho>(API_ROOT_URL+'/PhieuNhapKho_Update_VTK', item, { headers: httpHeaders });
	}PhieuNhapKho_Update_SL
	ChangeSL(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuNhapKho>(API_ROOT_URL+'/PhieuNhapKho_Update_SL', item, { headers: httpHeaders });
	}
	checkCancel(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PhieuNhapKho_Check_Cancel?IdNk=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	cancel(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PhieuNhapKho_Cancel?IdNk=${itemId}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	cancel_detail(IdCtNk: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PhieuNhapKhoCT_Cancel?IdCtNk=${IdCtNk}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	updateOnly(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuNhapKho>(API_ROOT_URL+'/PhieuNhapKho_Update_Only', item, { headers: httpHeaders });
	}
	duyet(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhieuNhapKho>(API_ROOT_URL+'/PhieuNhapKho_Update_StateConfirm', item, { headers: httpHeaders });
	}
	downloadExcel(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<Blob>(API_ROOT_URL + '/NK_ExportExcel', {
		  headers: httpHeaders,
		  responseType: 'blob' as 'json'
		});
	  }
	downloadExcelDetail(data): Observable<any> {
	const httpHeaders = this.httpUtils.getHTTPHeaders();
	return this.http.post<Blob>(API_ROOT_URL + '/NK_Export_Excel_Detail',
		data,
		 {
		headers: httpHeaders,
		responseType: 'blob' as 'json'
	});
	}
	/*---------------------------------------------------------------------- */

}
